import styled from "styled-components";
import { motion } from "framer-motion";
import { Title } from "@mui/icons-material";
export const ListingContainer = styled.div`
    display: flex;
    @media (max-width: 1100px) {
        display: block
    }
`

export const PortfolioHolder = styled(motion.div)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 100vh;
  width: 100%;
    @media (max-width: 1024px) {
        grid-template-columns: 1fr 1fr;
    }

    @media (max-width: 768px) {
        grid-template-columns: 1fr
    }
`

export const Tile = styled.div`
      width: 100%;
    position: relative;
    border: none;
    .box-front,
    .box-back {
      color: white;
      background: black;
      opacity: 1;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      @media (max-width: 600px) {
        font-size: 12px;
      }
      .tileInfo {
          font-size: 1rem;
          font-weight; 500;
          text-align: center;
          margin: 1rem 0;
          color: white;
      }
      .skillsUsed {
          font-family: "Open Sans", sans-serif;
          font-size: 0.9rem;
          font-weight: 400;
          color:rgb(236, 236, 236)
      }
      .buttons {
          padding: 1rem;
          text-align: center;
          a {
              text-decoration: none;
              color: white;
          }
          button {
              border: none;
              height: 80px;
              width: 80px;
              background: black;
              border: 1.5px solid white;
              color: white;
              border-radius: 100%;
              font-size: .88rem;
              transition-timing-function: cubic-bezier(.175, .885, .32, 1.275);
              transition-duration: .5s;
              transition-property: background;
              margin: 1rem;
              cursor: pointer;
              &:hover {
                  background: rgb(44, 44, 44);
              }
          }
      }
      p {
        font-size: 0.9125rem;
        color: #999;
      }
`

export const InnerTile = styled.div`
    ${Tile}:hover & {
        .box-front {
            transform: rotateY(180deg);
        }
        .box-back {
            opacity: 0.9;
            transform: rotateY(0deg);
        }         
    }
    .box-front,
      .box-back {
        transition-timing-function: cubic-bezier(.175, .885, .32, 1.275);
        transition-duration: .8s;
        transition-property: transform, opacity;
      }
      .front {
        transform: rotateY(0deg);
        }
      .box-back {
        position: absolute;
        opacity: 0;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transform: rotateY(-180deg);
      }
    img {
        width: 100%;
        height: 100%;
    }

`

export const PreviewPaneContainer = styled.div`
  position: absolute;
  height: 100vh;
  width: 100%;
  z-index: 2000;
  display: flex;
  align-items: center;

  .overlay {
    position: absolute;
    height: 100vh;
    width: 100%;
    z-index: 2500;
    background: #111;
    opacity: 0.9;
  }
`;

export const PreviewPaneHolder = styled(motion.div)`
  position: relative;
  z-index: 3000;
  border: 5px solid radial-gradient(circle, rgba(63,94,251,1) 0%, rgba(252,70,107,1) 100%);;
  border-radius: 30px 0 0 30px;
  width: min(100% - 5rem, 1300px);
  height: min(100% - 5rem, 1300px);
  margin-inline: auto;
  .btnContainer {
    text-align: center;
    margin: 2rem 0;
    background: black;
    padding: 2rem;
  }

  .cancelButton {
    position: absolute;
    top: 1rem;
    right: 1rem;
    cursor: pointer;
    font-size: 1.5rem;
  }

  iframe {
      width: 100%;
      height: 100%;
      border: none;
      border-radius: 30px 0 0 30px;
      &::-webkit-scrollbar {
          width: 7px;
      }
  }
`